export default "__VITE_ASSET__CiQbIHz5__"